var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../../../classes/runtime/Runtime';
let DraftBottomAd = class DraftBottomAd extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (!app.stage.draftLayout.shouldShowBottomAd)
            return null;
        return (React.createElement("div", { style: {
                height: 90,
                flex: '0 0 90px',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                zIndex: 1
            } }, this.ad));
    }
    get ad() {
        const { app } = this.props;
        if (!runtime.availablePackages.Defer) {
            return null;
        }
        const { GoogleAd, DfpAd } = runtime.availablePackages.Defer.components;
        if (runtime.solidBrowserRuntime.browserDevice.isTablet) {
            return React.createElement(GoogleAd, { app: app, style: { minWidth: 768, minHeight: 90 } });
        }
        return React.createElement(DfpAd, { app: app });
    }
};
DraftBottomAd = __decorate([
    observer
], DraftBottomAd);
export { DraftBottomAd };
//
